
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"hover-stroke",attrs:{"fill":"none","stroke":"#000","stroke-linejoin":"round","stroke-miterlimit":"10","d":"M11.999.68C5.658.68.499 5.797.499 12.089c0 2.497.814 4.81 2.191 6.69l-1.437 4.238 4.419-1.404A11.496 11.496 0 0012 23.5c6.34 0 11.499-5.118 11.499-11.41 0-6.291-5.158-11.41-11.5-11.41m6.907 14.535c-.084-.138-.308-.223-.643-.388-.336-.167-1.984-.972-2.291-1.082-.308-.111-.531-.167-.755.166-.223.333-.866 1.081-1.062 1.304s-.392.25-.727.084-1.415-.518-2.696-1.65c-.997-.883-1.669-1.971-1.864-2.305-.196-.332-.021-.512.146-.678.566-.558.706-.871.84-1.138.113-.221.056-.415-.028-.583-.084-.166-.755-1.803-1.034-2.467-.316-.757-1.725-.783-2.292-.169-1.789 1.941-1.376 4.141.196 6.216.168.222 2.319 3.69 5.728 5.022 3.408 1.331 3.408.887 4.023.831 1.767-.159 2.963-2.323 2.459-3.163"}}),_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0z"}})])
          )
        }
      }
    